<template>
  <form class="flat__form" @submit.prevent="onSubmit">
    <button class="flat__close" @click.prevent="close">
      <Icon :medium="true">
        <img src="@/assets/close.svg" alt="close" />
      </Icon>
    </button>
    <h3 class="flat__heading--form">{{ $t("form.title") }}</h3>
    <div class="flat__field">
      <label for="name" class="flat__label">{{ $t("form.name") }}</label>
      <input
        type="text"
        class="flat__input"
        id="name"
        name="name"
        v-model="name"
        :disabled="sent"
      />
      <p v-if="!validation.name" class="flat__error">
        {{ $t("form.name_error") }}
      </p>
    </div>
    <div class="flat__field">
      <label for="email" class="flat__label">{{ $t("form.email") }}</label>
      <input
        type="email"
        class="flat__input"
        name="email"
        id="email"
        v-model="email"
        :disabled="sent"
      />
      <p v-if="!validation.email" class="flat__error">
        {{ $t("form.email_error") }}
      </p>
    </div>
    <div class="flat__field">
      <label for="phone" class="flat__label">{{ $t("form.phone") }}</label>
      <input
        type="phone"
        class="flat__input"
        name="phone"
        id="phone"
        v-model="phone"
        :disabled="sent"
        maxlength="12"
      />
      <p v-if="!validation.phone" class="flat__error">
        {{ $t("form.phone_error") }}
      </p>
    </div>
    <div class="flat__field">
      <label for="message" class="flat__label">{{ $t("form.message") }}</label>
      <textarea
        name="message"
        id="message"
        class="flat__textarea"
        v-model="message"
        :disabled="sent"
      ></textarea>
      <p v-if="!validation.message" class="flat__error">
        {{ $t("form.message_error") }}
      </p>
    </div>
    <custom-checkbox
      :disabled="sent"
      id="checkbox-1"
      :shortText="$t('agree1Short')"
      :longText="$t('agree1')"
    ></custom-checkbox>
    <p v-if="!validation.checkboxes[0]" class="flat__error">
      {{ $t("form.check_error") }}
    </p>
    <custom-checkbox
      :disabled="sent"
      id="checkbox-2"
      :shortText="$t('agree2Short')"
      :longText="$t('agree2')"
    ></custom-checkbox>
    <p v-if="!validation.checkboxes[1]" class="flat__error">
      {{ $t("form.check_error") }}
    </p>
    <custom-checkbox
      id="checkbox-3"
      :disabled="sent"
      :shortText="$t('agree3Short')"
      :longText="$t('agree3')"
    ></custom-checkbox>
    <p v-if="!validation.checkboxes[2]" class="flat__error">
      {{ $t("form.check_error") }}
    </p>
    <div class="checkbox">
      <label for="checkbox-4" class="checkbox__label">
        {{ $t("agreeInfoShort") }}
        <p class="checkbox__tooltip" :style="{ fontSize: '8px' }">
          {{ $t("agreeInfo") }}
        </p>
      </label>
    </div>
    <input
      type="submit"
      :value="sent ? $t('form.sent') : $t('form.submit')"
      class="flat__submit"
      :disabled="sent"
      :class="{ sent: sent }"
    />
  </form>
</template>

<script>
// Components
import customCheckbox from "@/components/form/custom-checkbox.vue";
import Icon from "@/components/icon.vue";
import axios from "axios";

export default {
  name: "flatForm",
  props: ["flat"],
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      message: "",
      validation: {
        name: true,
        email: true,
        phone: true,
        message: true,
        checkboxes: [true, true, true],
      },
      sent: false,
    };
  },
  components: {
    customCheckbox,
    Icon,
  },
  mounted() {
    if (window.location.pathname.includes("en")) {
      this.message = `Hello, I'm interested in flat ${this.flat}. Please contact me.`;
    } else if (window.location.pathname.includes("de")) {
      this.message = `Hallo, ich interessiere mich für Wohnung ${this.flat}. Bitte kontaktiere mich.`;
    } else {
      this.message = `Witam, interesuje mnie apartament ${this.flat}. Proszę o kontakt.`;
    }
  },

  methods: {
    onSubmit(e) {
      e.preventDefault();
      let serialized = this.serialize(e.target);
      if (this.validateForm(serialized)) {
        axios
          .get(
            "https://cors-anywhere.indigital.guru/https://vacation.indigital.pl/inc/mailer.php",
            {
              params: {
                source: `Apartament ${this.flat} - Baltic Wave`,
                url: sessionStorage.getItem("source") || window.location.href,
                domain: "hotelbalticwave.pl",
                ...serialized,
              },
            }
          )
          .then(() => {
            this.sent = true;
            window.top.postMessage(`FORMULARZ_WYSLANY/${this.flat}`, "*");
          })
          .catch((error) => console.error(error));
      }
    },
    encode(data) {
      return Object.keys(data)
        .map(
          (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
        )
        .join("&");
    },
    serialize(form) {
      var field,
        s = {};
      if (typeof form == "object" && form.nodeName == "FORM") {
        var len = form.elements.length;
        for (let i = 0; i < len; i++) {
          field = form.elements[i];

          if (
            field.name &&
            !field.disabled &&
            field.type != "file" &&
            field.type != "reset" &&
            field.type != "submit" &&
            field.type != "button"
          ) {
            if (field.type == "select-multiple") {
              for (let j = form.elements[i].options.length - 1; j >= 0; j--) {
                if (field.options[j].selected)
                  s[field.name] = field.options[j].value;
              }
            } else if (
              (field.type != "checkbox" && field.type != "radio") ||
              field.checked
            ) {
              s[field.name] = field.value;
            }
          }
        }
      }

      return s;
    },
    validateForm(serializedData) {
      let validation = { checkboxes: [] };

      // Validate name
      if (!serializedData.name || serializedData.name.length <= 0) {
        validation.name = false;
      } else {
        validation.name = true;
      }

      // Validate e-mail
      let emailRegex = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
      if (
        !serializedData.email ||
        serializedData.email.length <= 0 ||
        !emailRegex.test(serializedData.email)
      ) {
        validation.email = false;
      } else {
        validation.email = true;
      }

      // Validate phone
      const phoneRegExp =
        /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i;
      if (
        !serializedData.phone ||
        serializedData.phone.length < 9 ||
        !phoneRegExp.test(serializedData.phone)
      ) {
        validation.phone = false;
      } else {
        validation.phone = true;
      }

      // Validate message
      if (!serializedData.message || serializedData.message.length <= 0) {
        validation.message = false;
      } else {
        validation.message = true;
      }

      // Validate checkboxes
      if (!serializedData["checkbox-1"] || !serializedData["checkbox-1"]) {
        validation.checkboxes[0] = false;
      } else {
        validation.checkboxes[0] = true;
      }

      if (!serializedData["checkbox-2"] || !serializedData["checkbox-2"]) {
        validation.checkboxes[1] = false;
      } else {
        validation.checkboxes[1] = true;
      }

      if (!serializedData["checkbox-3"] || !serializedData["checkbox-3"]) {
        validation.checkboxes[2] = false;
      } else {
        validation.checkboxes[2] = true;
      }

      this.validation = validation;

      for (let key in validation) {
        if (validation[key] === false) return false;
      }

      for (let checkbox of validation.checkboxes) {
        if (checkbox === false) return false;
      }

      return true;
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.flat__form {
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  min-width: 340px;
  min-height: 100%;
  z-index: 35;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  padding: 1.5rem 2rem;

  background: rgba(#fff, 0.95);
  box-shadow: 2px 2px 45px rgba(#000, 0.05);
  @media screen and (max-width: $md) {
    right: 0;
  }
  @supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
    background: rgba(#fff, 0.8);
    backdrop-filter: blur(10px);
  }
}

.flat__heading--form {
  font-size: 18px;
  font-weight: 500;
  color: #000;
  margin-bottom: 12px;
}

.flat__field {
  display: flex;
  flex-direction: column;
  margin-bottom: 4%;
}

.flat__label {
  font-size: 12px;
  font-weight: 400;
  color: #000;
  margin: {
    bottom: 4px;
  }
}

.flat__input,
.flat__textarea {
  height: 20px;
  border: none;
  border-bottom: 2px solid $lightGray;
  padding: 4px;
  background: transparent;
  font-family: inherit;
  font-size: 12px;
  line-height: 14px;
}

.flat__textarea {
  resize: none;
  height: 40px;
}

.flat__submit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;

  border-radius: 30px;
  border: 1px solid $primaryColor;
  background: $primaryColor;
  font-size: 14px;
  color: #fff;
  text-decoration: none;

  cursor: pointer;
  transition: 250ms;
  margin-top: 5%;

  &:hover {
    background: #fff;
    color: #000;
  }

  &.sent {
    cursor: initial;
    background: #fff;
    color: #000;
  }
}

.flat__close {
  position: absolute;
  top: 3%;
  right: 3%;
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
}

.flat__error {
  color: $sold;
  font-size: 12px;
}
</style>
